// extracted by mini-css-extract-plugin
export var borderRadius = "_eb-4";
export var large = "_eb-3";
export var logoContainer = "_eb-0";
export var nameLogo = "_eb-2";
export var small = "_eb-1";